export const selectStyles = {
  container: (base) => ({
    ...base,
    width: "100%",
  }),
  control: (base) => ({
    ...base,
    minHeight: "40px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999999,
  }),
  menuList: (base) => ({
    ...base,
    maxHeight: "200px",
    overflowY: "auto",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 16000,
  }),
};
